/**
 * api/upload.ts
 * ─────────────
 * Thin wrapper around POST /api/upload/local-item.
 *
 * Deliberately kept separate from inventory.ts so the upload module can be
 * imported in isolation for testing without pulling in the full inventory API.
 */

import { apiClient } from './client';

export interface UploadResponse {
  photo_id: string;
  status: string;
  filename: string;
}

/**
 * Stream a single image file to the backend Fly Volume.
 *
 * The browser sends a multipart/form-data body; the backend chunks it at
 * 64 KB to avoid buffering the whole payload in RAM.
 *
 * Throws an ``ApiError`` on any non-2xx response so the caller can
 * distinguish retryable (5xx / 429) from non-retryable (4xx) failures.
 */
export async function uploadPhoto(
  file: File,
  sessionId: string,
  missionId: string,
  warehouseId: string,
  /** Aisle the pilot is flying — attached as metadata for the triage endpoint. */
  aisle?: string,
): Promise<UploadResponse> {
  const form = new FormData();
  form.append('file', file);
  form.append('session_id', sessionId);
  form.append('mission_id', missionId);
  form.append('warehouse_id', warehouseId);
  if (aisle) form.append('aisle', aisle.trim().toUpperCase());
  return apiClient.postForm<UploadResponse>('/api/upload/local-item', form);
}
